import axios from 'axios'

const instance = axios.create({
    timeout: 30000,
    headers: { "X-Requested-With": "XMLHttpRequest" },
  });

export default () => ({
    loading: false,
    formSubmitted: false,
    originalButtonLabel: '',
    message: '',
    error: false,
    errors: [],
    success: false,

    init() {
        this.originalButtonLabel = this.$el.dataset.buttonText || 'Verstuur';
        
        if (!this.$el.dataset.buttonText) {
            const submitButton = this.$el.querySelector('button[type="submit"] span');
            if (submitButton && submitButton.textContent) {
                this.originalButtonLabel = submitButton.textContent.trim();
            }
        }
    },

    submit: function(event){
        if (this.formSubmitted) {
            return;
        }
        
        this.loading = true;
        const tagHandle = this.$el.dataset.handle
        const successMessage = this.$el.dataset.successMessage || 'Uw bericht is succesvol verstuurd! U ontvangt nog een bevestiging per e-mail.';

        const formData = new FormData(this.$el);
        instance.post(this.$el.action, formData)
            .then(async (response) => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': tagHandle
                });

                this.message = successMessage;
                this.error = false;
                this.success = true;
                this.formSubmitted = true;
                this.$el.reset();
            })
            .catch((error) => {
                this.error = true;
                this.errors = error.response.data.errors;
            })
            .finally(() => {
                this.loading = false;
            })
    },
})